import { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import { updateTicketState } from 'flow/actions/tickets-action';
import { selectTicketState } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { TicketStatus } from 'flow/types/Tickets';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import useTicketAction from 'flow/hooks/useTicketAction';

const useUpdateTicketState = (
    ticketKey: TicketKey,
    segmentComponent: string,
) => {
    const dispatch = useAppDispatch();
    const runTicketAction = useTicketAction();

    const ticketStatus = useAppSelector((state) =>
        selectTicketState(state, ticketKey),
    );

    const [isPerformingApiRequest, setIsPerformingApiRequest] = useState(false);

    const onSelect = useCallback(
        (newStatus: TicketStatus) => {
            if (newStatus === ticketStatus) return;

            setIsPerformingApiRequest(true);
            dispatch(
                segmentTrack(TICKET_STRINGS.USER_CHANGED_STATUS, {
                    component: segmentComponent,
                }),
            );
            runTicketAction(updateTicketState(ticketKey, newStatus)).finally(
                () => setIsPerformingApiRequest(false),
            );
        },
        [dispatch, ticketKey, ticketStatus, segmentComponent],
    );

    return { onSelect, isPerformingApiRequest };
};

export default useUpdateTicketState;
